import React from 'react';
import { SectionContainer, TextPairingContainer, StyledTextPairFlex, StyledBottomImage } from './ConnectedGuestListSection.styles';
import { Columns } from '@components/Columns';
import { Box } from '@components/Box';
import { CTALink } from '@components/CTALink';
import { useTranslation } from 'react-i18next';

export const ConnectedGuestListSection: React.FC = () => {
  const { t } = useTranslation('weddingInvitations');
  const connectedGuestSection = t('connectedGuestSection');
  const sectionId = 'ConnectedGuestListSection';
  return (
    <SectionContainer paddingBottom={[10, 12]} paddingTop={[13, 12]} id={sectionId}>
      <Columns centered>
        <Columns.Column width={12}>
          <StyledTextPairFlex flexDirection="column">
            <TextPairingContainer
              eyebrow={connectedGuestSection.eyebrow}
              eyebrowColor="humanaDark4"
              eyebrowVariant={'sectionEyeBrow24'}
              eyebrowTagName="h2"
              alignment={'center'}
              title={connectedGuestSection.title}
              titleVariant={'hed72Hero'}
              titleColor="neutra6"
              titleTagName="h2"
              body={connectedGuestSection.body}
              bodyColor="neutra5"
              bodyVariant="dek20"
            />
            <Box marginTop={[6]}>
              <CTALink id="explore-guest-list" hasChevron={true} typography="featureHed17" href="/guest-list">
                {connectedGuestSection.exploreGuestList}
              </CTALink>
            </Box>
          </StyledTextPairFlex>
        </Columns.Column>
      </Columns>
      <Columns marginTop={[10]} centered>
        <Columns.Column width={12}>
          <StyledBottomImage width="100%" src={connectedGuestSection.image} />
        </Columns.Column>
      </Columns>
    </SectionContainer>
  );
};
